/**
 * AdjusterStageNav — the adjuster Case Workspace nav chrome — a Stage Strip over the adjuster stages;
 * rendered ONLY for role="adjuster"; no Case Profile Bar (posture/claim-type is not the adjuster's concern here).
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StageStrip, stagesForRole, type StageStripItem } from './stage-strip';
import { CaseMatcherLink, CaseReconcileLink } from '../matcher/CaseMatcherLink';

export interface AdjusterStageNavProps {
  /** Base path for stage navigation (e.g. /adjuster/case/:caseId) */
  basePath: string;
  /** The currently viewed stage id */
  activeStageId: string;
  className?: string;
}

export function AdjusterStageNav({ basePath, activeStageId, className }: AdjusterStageNavProps) {
  const navigate = useNavigate();

  const stages: StageStripItem[] = stagesForRole('adjuster').map((s) => ({
    id: s.id,
    label: s.label,
  }));
  // caseId is the last path segment of basePath (/adjuster/case/:caseId) and equals the report_id.
  const reportId = basePath.split('/').filter(Boolean).pop() || '';

  return (
    <div className={className}>
      <div className="flex items-center justify-between gap-4 pr-4">
        <div className="min-w-0 flex-1">
          <StageStrip
            stages={stages}
            activeStageId={activeStageId}
            onNavigate={(id) => navigate(`${basePath}/${id}`)}
          />
        </div>
        <CaseMatcherLink reportId={reportId} />
        <CaseReconcileLink reportId={reportId} />
      </div>
    </div>
  );
}

export default AdjusterStageNav;
